import { type FC, useCallback, useState } from 'react';

import { Divider } from '@vakantiesnl/components/src/atoms/Divider';
import { Flight, hasTransferFlight } from '@vakantiesnl/components/src/molecules/Flight';
import { FlightTransfer } from '@vakantiesnl/components/src/molecules/FlightTransfer';
import { ModalOrDrawer } from '@vakantiesnl/components/src/molecules/ModalOrDrawer/ModalOrDrawer';
import { type MicroCopy, type Search } from '@vakantiesnl/types';

import { useStyles } from './FlightsOverview.styles';

export type FlightSelectorProps = {
	inbound: Search.Flight;
	outbound: Search.Flight;
	microCopy: MicroCopy;
};

export const FlightsOverview: FC<FlightSelectorProps> = (props) => {
	const { inbound, microCopy, outbound } = props;
	const { classes } = useStyles();

	const hasTransfer = hasTransferFlight(inbound, outbound);

	const [flightModalData, setFlightModalData] = useState<null | {
		flight: Search.Flight | null;
		isOutbound: boolean;
	}>(null);

	const toggleTransferModal = useCallback(
		(flight: Search.Flight | null, isOutbound = false) =>
			() => {
				if (!flight) {
					setFlightModalData(null);
					return;
				}

				setFlightModalData({ flight, isOutbound });
			},
		[],
	);

	return (
		<div className={classes.flightsContainer} data-cy="flights-overview">
			<div className={classes.flights}>
				<Flight
					flight={outbound}
					microCopies={microCopy}
					isOutbound={true}
					onClickStopOverButton={toggleTransferModal(outbound, true)}
					showLeadingAirPlaneIcons
				/>
				<Divider className={classes.isMobileOnly} noMargins />
				<Flight
					flight={inbound}
					microCopies={microCopy}
					isOutbound={false}
					onClickStopOverButton={toggleTransferModal(inbound)}
					showLeadingAirPlaneIcons
				/>
			</div>
			{hasTransfer && !!flightModalData?.flight && (
				<ModalOrDrawer
					open={!!flightModalData}
					title={microCopy['common.transferFlightDetails']}
					hasCloseIcon={true}
					onClose={toggleTransferModal(null)}
					direction="up"
				>
					<FlightTransfer flight={flightModalData.flight} isOutbound={!!flightModalData.isOutbound} />
				</ModalOrDrawer>
			)}
		</div>
	);
};
